import { ReadingRecord } from '../types/records';

const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getTotalMinutes = (records: ReadingRecord[]) =>
  records.reduce((sum, r) => sum + r.minutes, 0);

export const createDateStr = (date: Date) =>
  `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;

export const isSameDate = (recordDate: Date, currentDate: Date) =>
  recordDate.getMonth() === currentDate.getMonth() &&
  recordDate.getDate() === currentDate.getDate() &&
  recordDate.getFullYear() === currentDate.getFullYear();

export const getWeekRecords = (records: ReadingRecord[]) => {
  const todayObj = new Date();
  const todayDate = todayObj.getDate();
  const todayDay = todayObj.getDay();
  const firstDayOfWeek = new Date(todayObj.setDate(todayDate - todayDay));
  firstDayOfWeek.setHours(0, 0, 0, 0);
  const lastDayOfWeek = new Date(firstDayOfWeek);
  lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);
  lastDayOfWeek.setHours(23, 59, 59, 999);
  return records.filter((r) => {
    const d = new Date(r.date);
    return d >= firstDayOfWeek && d <= lastDayOfWeek;
  });
};

export const getYearRecords = (records: ReadingRecord[], year: number) =>
  records.filter((r) => new Date(r.date).getFullYear() === year);

export const mapWeeklyTotals = (records: ReadingRecord[]) => {
  const data = daysOfWeek.map((day) => ({ day, minutes: 0, sessions: 0 }));
  for (const r of records) {
    const idx = new Date(r.date).getDay();
    data[idx].minutes += r.minutes;
    data[idx].sessions += 1;
  }
  return data;
};

export const mapMonthlyTotals = (records: ReadingRecord[]) => {
  const data = months.map((month) => ({ month, minutes: 0, sessions: 0 }));
  for (const r of records) {
    const idx = new Date(r.date).getMonth();
    data[idx].minutes += r.minutes;
    data[idx].sessions += 1;
  }
  return data;
};

export const getCurrentStreak = (records: ReadingRecord[]) => {
  if (records.length === 0) return 0;
  const sorted = [...records].sort((a, b) => b.date - a.date);
  const map = new Map<string, boolean>();
  const today = new Date();
  let streak = 0;

  if (isSameDate(new Date(sorted[0].date), today)) {
    streak = 1;
    const todayStr = createDateStr(today);
    const remaining = sorted.filter((r) => createDateStr(new Date(r.date)) !== todayStr);
    const cursor = new Date();
    cursor.setDate(today.getDate() - 1);
    for (const r of remaining) {
      const d = new Date(r.date);
      const ds = createDateStr(d);
      if (map.has(ds)) continue;
      if (isSameDate(d, cursor)) {
        streak++;
        cursor.setDate(cursor.getDate() - 1);
        map.set(ds, true);
      } else break;
    }
  }
  return streak;
};

export const getLongestStreak = (records: ReadingRecord[]) => {
  const sorted = [...records].sort((a, b) => b.date - a.date);
  if (sorted.length === 0) return 0;
  let longest = 0;
  let current = 0;
  let cursor = new Date(sorted[0].date);
  const map = new Map<string, boolean>();
  for (const r of sorted) {
    const d = new Date(r.date);
    const ds = createDateStr(d);
    if (map.has(ds)) continue;
    map.set(ds, true);
    if (current === 0) cursor = new Date(r.date);
    if (isSameDate(d, cursor)) {
      current++;
      if (current > longest) longest = current;
    } else {
      current = 0;
    }
    cursor.setDate(cursor.getDate() - 1);
  }
  return longest;
};
